import { faCalendarDay } from "@fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetFamilyByIdQuery } from "../../../redux/apiStore";
import { EditFamilyDrawer } from "../edit";
import { ChildrenTable } from "./ChildrenTable";
import { ContactsTable } from "./ContactsTable";
import { FamilyDetailAppBarSetup } from "./FamilyDetailAppBarSetup";

export function FamilyDetailPage() {
  const params = useParams();
  const familyId = parseInt(params.familyId || "");
  const getFamilyById = useGetFamilyByIdQuery({ id: familyId });
  const family = getFamilyById?.data;
  const [editDrawerOpen, setEditDrawerOpen] = useState<boolean>(false);

  return (
    <Stack sx={{ p: 2, pt: 0 }} gap={2}>
      {getFamilyById.isLoading ? <LinearProgress /> : <Box sx={{ height: 4 }} />}
      <FamilyDetailAppBarSetup />
      <Paper sx={{ p: 2 }}>
        <Stack direction="row">
          <Typography variant="h6" sx={{ mb: 1, flexGrow: 1 }}>
            Details
          </Typography>
          <Button variant="outlined" onClick={() => setEditDrawerOpen(true)}>
            Edit
          </Button>
        </Stack>
        <Box>
          <Typography variant="body1">{family?.payerName}</Typography>
          <Typography variant="body1">{family?.address}</Typography>
          <Typography variant="body1">
            {family?.city} {family?.state}, {family?.zipCode}
          </Typography>
          <Typography variant="body1">{family?.phone}</Typography>
          <Box sx={{ mt: 1 }}>
            <FontAwesomeIcon icon={faCalendarDay} /> {family?.paymentFrequency} Payments
          </Box>
        </Box>
      </Paper>
      <EditFamilyDrawer family={family} open={editDrawerOpen} onClose={() => setEditDrawerOpen(false)} />
      <ContactsTable familyId={familyId} />
      <ChildrenTable familyId={familyId} />
    </Stack>
  );
}
